(() => {
  const boot = (scope = document) => scope.querySelectorAll('[data-mp-buybox]').forEach(box => {
    if (box.dataset.mpPickerReady) return;
    box.dataset.mpPickerReady = 'true';
    const form = box.querySelector('form');
    const select = box.querySelector('[data-mp-select]');
    const input = box.querySelector('[data-mp-id]');
    const atc = box.querySelector('[data-mp-atc]');
    if (!form || !input || !atc) return;
    let variants = [];
    try { variants = JSON.parse(box.querySelector('[data-mp-variants]')?.textContent || '[]'); } catch { return; }
    const choices = box.querySelector('[data-mp-choices]');
    const setText = (selector, text) => { const el = box.querySelector(selector); if(el) el.textContent = text; };
    if (select && choices && select.options.length <= 12) {
      [...select.options].forEach(option => {
        const variant = variants.find(v => String(v.id) === option.value);
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.variantChoice = option.value;
        button.textContent = option.textContent.trim();
        button.setAttribute('aria-pressed', String(option.selected));
        button.classList.toggle('is-sold-out', !variant?.available);
        button.addEventListener('click', () => { select.value = option.value; select.dispatchEvent(new Event('change',{bubbles:true})); });
        choices.append(button);
      });
      choices.hidden = false;
      const nativeRow = select.closest('.mp-buybox__row');
      if (nativeRow) nativeRow.hidden = true;
    }
    const apply = (updateUrl = false) => {
      const option = select?.selectedOptions[0];
      const variant = variants.find(v => String(v.id) === (option?.value || input.value)) || variants[0];
      if (!variant) return;
      input.value = String(variant.id);
      input.dispatchEvent(new Event('change', {bubbles:true}));
      atc.disabled = !variant.available;
      setText('[data-mp-atc-label]', variant.available ? atc.dataset.label : atc.dataset.labelSoldout);
      const stock = box.querySelector('[data-mp-stock]');
      if (stock) stock.hidden = variant.available;
      if (option) {
        setText('[data-mp-price]', option.dataset.price);
        for (const [selector,value] of [['[data-mp-was]',option.dataset.compare],['[data-mp-save]',option.dataset.save ? `${option.dataset.save}%` : '']]) {
          const el = box.querySelector(selector);
          if(el) { el.textContent = value || ''; el.hidden = !value; }
        }
      }
      choices?.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.variantChoice === String(variant.id))));
      const dynamic = box.querySelector('[data-mp-dynamic-checkout]');
      if(dynamic) { dynamic.hidden = !variant.available; dynamic.inert = !variant.available; }
      const section = box.closest('.shopify-section');
      section?.querySelectorAll('[data-ss-sticky-atc]').forEach(bar => {
        const button = bar.querySelector('button');
        if(button) { button.disabled = !variant.available; const label = button.querySelector('span'); if(label) label.textContent = variant.available ? atc.dataset.label : atc.dataset.labelSoldout; }
        const price = bar.querySelector('[data-ss-price]');
        if(price && option) price.textContent = option.dataset.price;
        const compare = bar.querySelector('.ss-satc__was');
        if(compare && option) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
      });
      if(updateUrl) { const url = new URL(location.href); url.searchParams.set('variant',variant.id); history.replaceState({},'',url); }
      box.dispatchEvent(new CustomEvent('mp:variant:change',{bubbles:true,detail:variant}));
    };
    select?.addEventListener('change', () => apply(true));
    apply();
  });
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(),{once:true}); else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
